<div class="display-entity" *ngIf="haveEntities">
  <ng-container
    *ngTemplateOutlet="entityTemplate; context: { entities: companiesEntities, title: 'Companies' }"></ng-container>
  <ng-container
    *ngTemplateOutlet="entityTemplate; context: { entities: groupsEntities, title: 'Groups' }"></ng-container>
  <ng-container
    *ngTemplateOutlet="entityTemplate; context: { entities: vehiclesEntities, title: 'Vehicles' }"></ng-container>
  <ng-container
    *ngTemplateOutlet="entityTemplate; context: { entities: devicesEntities, title: 'Devices' }"></ng-container>
</div>

<ng-template #entityTemplate let-entities="entities" let-title="title">
  <div *ngIf="entities.length > 0" class="display-entity__entities_title">{{ title }}</div>
  <span class="display-entity__container">
    <span class="display-entity__entity-name">{{ entities }}</span>
  </span>
</ng-template>